import React from 'react';
import { Vehicle } from '@/services/api/vehicles';

interface VehicleDetailHeaderProps {
  vehicle: Vehicle;
  onBack: () => void;
  actionButton?: React.ReactNode;
}

const formatTimestamp = (value?: string | null) => {
  if (!value) return '-';

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;

  const datePart = new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  }).format(parsed);

  const timePart = new Intl.DateTimeFormat('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(parsed);

  return `${datePart}, ${timePart.replace(':', '.')}`;
};

const VehicleDetailHeader: React.FC<VehicleDetailHeaderProps> = ({
  vehicle,
  onBack,
  actionButton,
}) => {
  const timestampLabel = 'Created on';
  const timestampValue = formatTimestamp(vehicle.createdAt);
  const actor = vehicle.createdBy;

  return (
    <div className="mb-4">
      <div className="flex items-start justify-between">
        <div className="flex items-start gap-3">
          <button
            onClick={onBack}
            className="mt-0.5 inline-flex h-9 w-9 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-600 hover:bg-gray-50"
            aria-label="Back"
          >
            <svg
              className="h-5 w-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>

          <div>
            <h1 className="text-xl font-semibold text-gray-900">
              {vehicle.platNomor || '-'}
            </h1>
            <p className="mt-0.5 text-xs text-gray-500">
              {timestampLabel} {timestampValue} by {actor || '-'}
            </p>
          </div>
        </div>

        {actionButton && <div className="mt-0.5">{actionButton}</div>}
      </div>
    </div>
  );
};

export default VehicleDetailHeader;
